import { supabase } from './supabase';

const backendUrl =
  (import.meta as any).env?.VITE_BACKEND_API_URL ||
  'https://fcc-summarize-app-r4ac3.ondigitalocean.app';

export interface TopicBundle {
  key: string;
  label: string;
  blurb: string;
  seed_docket_count: number;
}

export interface TopicSubscription {
  id: string;
  user_id: string;
  bundle_key: string | null;
  label: string;
  keywords: string[];
  auto_follow: boolean;
  created_at: string;
}

async function currentUserId(): Promise<string | null> {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  return user?.id ?? null;
}

export const topicSubscriptionService = {
  async getBundles(): Promise<TopicBundle[]> {
    const res = await fetch(`${backendUrl}/api/topic-bundles`);
    if (!res.ok) return [];
    const data = await res.json();
    return data.bundles ?? [];
  },

  /** Subscribe to a curated bundle: creates the standing interest and
   * seed-follows its dockets. Returns the dockets that were followed. */
  async subscribe(
    bundleKey: string
  ): Promise<{ followed_dockets: string[] } | null> {
    const userId = await currentUserId();
    if (!userId) return null;
    const res = await fetch(`${backendUrl}/api/topic-subscriptions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, bundle_key: bundleKey }),
    });
    if (!res.ok) return null;
    return res.json();
  },

  async list(): Promise<TopicSubscription[]> {
    const userId = await currentUserId();
    if (!userId) return [];
    const res = await fetch(
      `${backendUrl}/api/topic-subscriptions?user_id=${encodeURIComponent(
        userId
      )}`
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data.subscriptions ?? [];
  },

  async remove(subscriptionId: string): Promise<boolean> {
    const userId = await currentUserId();
    if (!userId) return false;
    const res = await fetch(
      `${backendUrl}/api/topic-subscriptions/${subscriptionId}?user_id=${encodeURIComponent(
        userId
      )}`,
      { method: 'DELETE' }
    );
    return res.ok;
  },
};
